const clustersNames = [
    {
        id: "1",
        name: 'Sostenibilidad'
    },
    {
        id: "2",
        name: 'Capacitación'
    },
    {
        id: "3",
        name: 'Capital de trabajo'
    },
    {
        id: "4",
        name: 'Ejecución punto de venta'
    },
    {
        id: "5",
        name: 'Financiación'
    },
    {
        id: "6",
        name: 'Inventario'
    },
    {
        id: "7",
        name: 'Manejo digital'
    },
    {
        id: "8",
        name: 'Plan comercial y análisis'
    },
    {
        id: "9",
        name: 'Portafolio'
    },
    {
        id: "11",
        name: 'Repuestos'
    },
    {
        id: "12",
        name: 'Servicio al cliente'
    },
    {
        id: "13",
        name: 'Servicio técnico'
    },
]

export default clustersNames